import { useState } from "react";
import { Printer } from "lucide-react";
import { toast } from "sonner";
import { openPdf } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const PrintButton = ({ path, label = "Print PDF", testId, size, variant = "outline" }) => {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await openPdf(path); } catch { toast.error("Could not generate PDF"); } finally { setBusy(false); }
  };
  return (
    <Button size={size} variant={variant} onClick={go} disabled={busy} data-testid={testId} title={label}>
      <Printer className={label ? "mr-1.5 h-4 w-4" : "h-4 w-4"} />{label}
    </Button>
  );
};
